import * as St from './CardSaleImg.styles';

const CardSaleImg = (): JSX.Element => (
  <St.Container>
    <St.CardSaleImg
      src={'./public/assets/images/Tags/sale-tag.svg'}
      alt="sale-tag"
    />
  </St.Container>
);

export default CardSaleImg;
